import { classNamesFor } from '../../../utils/classNames';

import { marketingBannerSizes } from './constants';

const factory = classNamesFor('MarketingBanner');

export const marketingBannerClassNames = {
  root: factory.root(),
  content: factory.element('content'),
  text: factory.element('text'),
  title: factory.element('title'),
  message: factory.element('message'),
  action: factory.element('action'),
  endContent: factory.element('endContent'),
  closeButton: factory.element('closeButton'),
  ...factory.toAttrClasses('size', marketingBannerSizes),
};
